import React, { useContext, useState } from 'react';
import { Flex } from 'antd';

import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import VendorAliasDialog from '@totem/components/vendors/vendorAliasDialog/VendorAliasDialog';
import VendorLogoContext from '@totem/components/vendors/vendorLogos/vendorLogoContext';
import { isNotNull, isNull } from '@totem/utilities/common';

const styles = {
  vendorName: {
    marginLeft: '16px',
  },
};

type Props = {
  vendorName: string;
  iconWidth?: number;
  iconHeight?: number;
};

const VendorDisplay = ({ vendorName, iconHeight, iconWidth }: Props) => {
  const { userProfile } = useContext(UserProfileContext);
  const { rawVendorData } = useContext(VendorLogoContext);
  const [showAddAlias, setShowAddAlias] = useState(false);

  const canAddAlias =
    permissions.internalSystemAdministrator.hasPermissions(userProfile);

  console.log(`Vendor Name: ${vendorName}`);

  let displayName = vendorName;
  if (isNotNull(rawVendorData) && rawVendorData.length > 0) {
    let vendorRecord = rawVendorData.find((chk) => chk.name === vendorName);
    console.log(`Vendor Record 1: ${JSON.stringify(vendorRecord)}`);
    if (isNull(vendorRecord)) {
      vendorRecord = rawVendorData.find((chk) =>
        chk.aliases.includes(vendorName),
      );

      console.log(`Vendor Record 1: ${JSON.stringify(vendorRecord)}`);
      if (isNotNull(vendorRecord)) {
        displayName = vendorRecord.name;
      }
    } else {
      displayName = vendorRecord.name;
    }

    if (
      isNotNull(vendorRecord) &&
      vendorRecord.name === displayName &&
      isNotNull(vendorRecord.logo) &&
      vendorRecord.logo.mimeType !== '' &&
      vendorRecord.logo.base64Image !== ''
    ) {
      return (
        <Flex justify={'flex-start'} align={'center'}>
          <img
            src={`data:${vendorRecord.logo.mimeType};base64,${vendorRecord.logo.base64Image}`}
            alt="Logo"
            height={iconHeight ?? 24}
            {...(iconWidth !== undefined ? { width: iconWidth } : {})}
          />
          <div style={styles.vendorName}>{vendorRecord.name}</div>
        </Flex>
      );
    }
  }

  const canDoEdit = canAddAlias && vendorName === displayName;

  return (
    <span>
      {canDoEdit && (
        <span
          style={{ color: '#19a6e0' }}
          onClick={() => setShowAddAlias((prevState) => !prevState)}
        >
          {displayName}
        </span>
      )}
      {!canDoEdit && <span>{displayName}</span>}

      {canDoEdit && showAddAlias && (
        <VendorAliasDialog
          open={showAddAlias}
          onClose={() => setShowAddAlias(false)}
          defaultAlias={vendorName}
        />
      )}
    </span>
  );
};

export default VendorDisplay;
